function resetTypeFilters() {
  this.$data.settings.filters.productCategory = false;
  this.$data.settings.filtersText.typesText = false;
  this.$data.settings.filtersValues.typesVal = [];
}
export default resetTypeFilters;
